"use strict";

import {EventEmitter} from "events";

export default class Singleton extends EventEmitter {
	
	constructor() {
		super();
		this.setMaxListeners(Infinity);
		this.item = null;
	}
	
	// PUBLIC METHODS
	
	get() {
		return this.item;
	}
	
	// PRIVATE METHODS
	
	set(item) {
		this.item = item;
		this.emit('change', item);
	}
	
}


// WEBPACK FOOTER //
// ./~/vwa/flux/Singleton.js